import Ajax from '@/lib/ajax'

export default {
    getList(pageSize: number, currentPage: number, Sorting?: string) {
        let params = {
            Sorting,
            MaxResultCount: pageSize,
            SkipCount: currentPage <= 1 ? 0 : (currentPage - 1) * pageSize
        }
        return Ajax.get('/api/productManagement/importTask', {
            params: params
        })
    }
}